import { Link } from 'expo-router';
import type { StyleProp, ViewStyle } from 'react-native';
import { ChatHomeListItemFragment } from '@/components/Chat/ChatHomeListItem.utils';
import { type FragmentOf, readFragment } from '@/gql/graphql';
import ChatHomeListItem from './ChatHomeListItem';

export interface ChatHomeListItemProps {
  fragment: FragmentOf<typeof ChatHomeListItemFragment>;
  onHide: (chatId: string) => void;
  onSetSilenced: (chatId: string, isSilenced: boolean) => void;
}

interface ChatHomeListItemContentProps
  extends Pick<ChatHomeListItemProps, 'fragment'> {
  itemStyle?: StyleProp<ViewStyle>;
}

export default function ChatHomeListItemContent({
  fragment,
  itemStyle,
}: ChatHomeListItemContentProps) {
  const chat = readFragment(ChatHomeListItemFragment, fragment);

  return (
    <ChatHomeListItem.Provider fragment={fragment}>
      <Link
        href={{ pathname: '/chat/[chatId]', params: { chatId: chat.id } }}
        asChild
      >
        <ChatHomeListItem.Pressable
          itemStyle={itemStyle}
          testID="ChatHomeListItem"
        >
          <ChatHomeListItem.Avatar />
          <ChatHomeListItem.Body>
            <ChatHomeListItem.Header>
              <ChatHomeListItem.Identity />
              <ChatHomeListItem.Status>
                <ChatHomeListItem.UnseenCount />
                <ChatHomeListItem.SilencedStatus />
                <ChatHomeListItem.Date />
              </ChatHomeListItem.Status>
            </ChatHomeListItem.Header>
            <ChatHomeListItem.LastMessage />
          </ChatHomeListItem.Body>
        </ChatHomeListItem.Pressable>
      </Link>
    </ChatHomeListItem.Provider>
  );
}
